import React, { useEffect, useRef, useState } from "react";
import { PatientInfo } from "./patientInfo";
import { alertService } from '../../services/helpers/alert.service';
import { useLocation, useNavigate } from "react-router-dom";
import { Input } from "@progress/kendo-react-inputs";
import { Form, Field, FormElement} from "@progress/kendo-react-form";

const tryDecodeParams = (location) => {
    const searchParams = new URLSearchParams(location.search);

    try {
        var param = searchParams.get("q");
        if (param) {
            let ret = JSON.parse(atob(param));
            return ret;
        }
        let sessionCNP = sessionStorage.getItem('patient_search');
        let sessionComponent = sessionStorage.getItem('patient_active_component');

        if (!sessionComponent) {
            sessionComponent = "Subscriptions";
        }

        if (sessionCNP && sessionComponent) {
            let ret = {
                cnp : sessionCNP,
                activeComponent : sessionComponent
            }
            return ret;
        }
    }
    catch {
    }

    return {};
}

export const Patient = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const rol = sessionStorage.getItem('rol');
    const decodedParam = tryDecodeParams(location);
    var initialValues = { cnp: decodedParam && decodedParam.cnp ? decodedParam.cnp :  ""  };

    const formRef = useRef();

    const [cnp, setCnp] = useState(initialValues.cnp);
    const [activeComponent, setActiveComponent] = useState(decodedParam && decodedParam.activeComponent ? decodedParam.activeComponent : null);

    // Utilizatorii CMU nu au drept de vizualizare a acestei pagini
    useEffect(() => {
        if (rol == 2) {
            navigate('/dashboard/cautare/');
        }
    }, []);




    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            setCnp(formRef.current?.values?.cnp ?? '');
        }
    }

    
    const handleKeypress = (e) => {
        if (e.key === 'Enter') {
            handleClick("Subscriptions");
        }
    };
    

    const handleClick = (componentName) => {
        const specialCons = sessionStorage.getItem('haveLocationsSpecialCons');

        if (componentName == "AddSpecialConsultation" && specialCons == "false") {
            alertService.error("Nu se poate adauga consultatie speciala pentru acest partener!");
            return;
        }

        let _cnp = formRef.current?.values?.cnp ?? '';
        setCnp(_cnp);

        // Salvează CNP-ul în sessionStorage pentru a-l putea folosi în alte componente
        sessionStorage.setItem('patient_search', _cnp);
        sessionStorage.setItem('patient_active_component', componentName)

        if (_cnp !== "") {
            setActiveComponent(componentName);
        } else {
            alertService.error("Nu ai completat CNP-ul! ");
        }
    };

    // Render
    return (
        <>
            <h2 className="titlu">Cautare pacienţi</h2>
            <p className="paragraf">Introduceti codul sau CNP-ul pacientului si cautati abonamentele valide ale acestuia in locatia curenta sau consultatiile lui anterioare.</p>
            <div className="formular pt20">
                <fieldset>
                    <div data-name="error"> </div>
                    <Form
                        ref={formRef}
                        initialValues={initialValues}
                        render={() => (
                            <FormElement>
                                <p className="d-flex align-items-center pb10">
                                    <label className="mr10 pt5">Codul sau CNP-ul</label>
                                    <Field
                                        component={CnpInput}
                                        className="w200 fl"
                                        name="cnp"
                                        type="text"
                                        maxLength="13"
                                        onKeyDown={handleKeyDown}
                                        onKeyPress={handleKeypress}
                                        value={cnp}
                                    />
                                </p>
                            </FormElement>
                        )}
                    />                       
                    <ul className="submenu pt10 clearfix">
                        <li className="">
                            <button
                                data-name="Subscriptions"
                                className={activeComponent == "Subscriptions" ? "button_activ": ""}
                                name="cauta_abonamente"
                                onClick={() => handleClick("Subscriptions")}
                            >
                                Abonamente pacient
                            </button>
                        </li>
                        <li className="">
                            <button
                                data-name="Consultations"
                                className={activeComponent == "Consultations" ? "button_activ" : ""}
                                name="cauta_consultatii"
                                onClick={() => handleClick("Consultations") }
                            >
                                Consultatii anterioare
                            </button>
                        </li>
                        <li className="">
                            <button
                                data-name="Preauthorizations"
                                className={activeComponent == "Preauthorizations" ? "button_activ" : ""}
                                name="cauta_preautorizari"
                                onClick={() => handleClick("Preauthorizations")}
                            >
                                Preautorizari anterioare
                            </button>
                        </li>
                        <li className="">
                            <button
                                data-name="AddSpecialConsultation"
                                className={activeComponent == "AddSpecialConsultation" ? "button_activ" : ""}
                                name="consultatie_speciala"
                                onClick={() => handleClick("AddSpecialConsultation")}
                            >
                                Adaugare consultatie speciala
                            </button>
                        </li>
                        <li className="">
                            <button
                                data-name="MMRecords"
                                className={activeComponent == "MMRecords" ? "button_activ" : ""}
                                name="fisa_mm"
                                onClick={() => handleClick("MMRecords")}
                            >Fise anterioare MM</button>
                        </li>
                        <li className="">
                            <button
                                data-name="MMTemporaryAlocation"
                                className={activeComponent == "MMTemporaryAlocation" ? "button_activ" : ""}
                                name="alocare_temp_mm"
                                onClick={() => handleClick("MMTemporaryAlocation")}
                            >Alocare temporara MM</button>
                        </li>
                        <li className="">
                            <button
                                data-name="MMPreauthorization"
                                className={activeComponent == "MMPreauthorization" ? "button_activ" : ""}
                                name="preautorizari_mm"
                                onClick={() => handleClick("MMPreauthorization")} >Preautorizari anterioare MM </button>
                        </li>
                    </ul>
                </fieldset>
            </div>

            { activeComponent && <PatientInfo cnp={cnp} activeComponent={activeComponent} ></PatientInfo> }
     </>
	);
};


const CnpInput = (props) => {
    const { value, onChange, ...others } = props;
    const [_value, _setValue] = useState(value);

    const handleChange = (event) => {
        const pattern = /^[0-9]*$/;
        if (!pattern.test(event.value)) {
            return;
        }
        _setValue(event.value);
        if (onChange) {
            onChange(event);
        }
    }

    return <Input
        {...others}
        onChange={handleChange}
        value={_value}
    />

}